import React from "react";
import { makeStyles} from "@material-ui/styles";
import { Dialog, AppBar, Toolbar, Icon, DialogContent, Typography, Button, Table, TableBody, TableHead, TableRow, TableCell } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles({
    modalHeader: {
        height: "80px",
        background: "#F7941E",
        fontSize: "20px",
        color: "#fff",
        flexDirection: "initial",
    },
    paperWidthSm: {
        width: "850px",
        maxWidth: "80%",
    },
});


export default function ModalConfirm({ open, setOpen, cart, confirm}) {
    const classes = useStyles();

    function getTotal(name) {
        const items = cart ? Object.values(cart) : [];
        const field = name;
        let total = 0;

        for (let i in items) {
            if (name === 'quantity') total += items[i][1][field]
            else {
                total += items[i][1][field] ? items[i][1][field] : items[i][1]['price']
            }
        }
        return total
    }


    return (

            <Dialog open={open} classes={{ paperWidthSm: classes.paperWidthSm }}>
                <AppBar className={classes.modalHeader} position="static" elevation={1} >
                    <Toolbar
                        style={{ justifyContent: "space-between", width:"100%" }}
                        className="flex w-full"
                    >
                        <p>
                            Confirmación de pedido
                        </p>
                        <Button onClick={()=>setOpen(false)} style={{color:"white", cursor:'pointer'}}>
                        <CloseIcon />
                        </Button>
                        
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div className="flex w-full flex-col">
                        {/* <div className="flex flex-col">
                            <div className="flex flex-row">
                                <Typography style={{marginRight:'1rem', fontWeight:'bold'}}>Cliente:</Typography>
                                <span>{opportunityData ? opportunityData['name'] : ''}</span>
                            </div>
                            <div className="flex flex-row">
                                <Typography  style={{marginRight:'1rem', fontWeight:'bold'}}>Vendedor:</Typography>
                                <span>{seller['n']}</span>
                            </div>
                        </div> */}
                        <div className="flex flex-col overflow-x-scroll overflow-y-hidden">
                            <Table className="modal-table mt-12">
                                <TableHead>
                                    <TableRow>
                                        {[
                                            "Código",
                                            "Nombre",
                                            "Cant.",
                                            "P.Uni.",
                                            "Sub T.",
                                        ].map((t, i) => (
                                            <TableCell key={i}>{t}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {cart ? Object.values(cart).map((item, i) => {
                                        return (
                                            <TableRow key={i}>
                                                <TableCell>
                                                    <p>{item[1]['rk']}</p>
                                                </TableCell>
                                                <TableCell>
                                                    <p style={{ whiteSpace: "nowrap" }}>{item[1]['n']}</p>
                                                </TableCell>
                                                <TableCell>
                                                    <p>{item[0]}</p>
                                                </TableCell>
                                                <TableCell>
                                                    <p>${item[1]['price']}</p>
                                                </TableCell>
                                                <TableCell>
                                                    <p>${item[1]['total'] ? item[1]['total'] : item[1]['price']}</p>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                        : null}

                                    <TableRow>
                                        <TableCell style={{ fontWeight: "bold" }}>
                                            TOTAL
                                        </TableCell>
                                        <TableCell></TableCell>
                                        <TableCell style={{ fontWeight: "bold" }}>
                                            {getTotal('quantity')}
                                        </TableCell>
                                        <TableCell></TableCell>
                                        <TableCell style={{ fontWeight: "bold" }}>
                                            {/* {formatTotal(order.tt.t)} */}
                                            {`$${parseFloat(getTotal('total')).toFixed(2)}`}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                        <div className="self-end" style={{margin:'2rem 0rem', textAlign:"end"}}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="capitalize"
                                onClick={() => confirm()}
                                >
                                Confirmar
                            </Button>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
    )


}